module.exports = __webpack_public_path__ + "static/media/sg9cr658.980fb070.png";